import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-ce76065a"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "no-redirect"
};
const _hoisted_2 = {
  key: 0
};
const _hoisted_3 = {
  key: 1
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = {
  key: 0
};
const _hoisted_6 = {
  key: 1
};
import { constantRoutes } from '@/router';
import { watch, ref, onMounted } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
export default /*#__PURE__*/_defineComponent({
  __name: 'breadcrumb',
  setup(__props) {
    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    const yuyan = ref(false);
    onMounted(() => {
      qiehuanZhEn(localStorage.getItem('lang') || 'zh');
    });
    const breadcrumbList = ref([]);
    const initBreadcrumbList = () => {
      console.log(route.matched[0].path);
      if (route.matched[0].path === '/') {
        breadcrumbList.value = [];
        breadcrumbList.value.push(route.matched[1]);
        return;
      }
      const temp = [constantRoutes[1]];
      breadcrumbList.value = temp.concat(route.matched);
      console.log(breadcrumbList.value);
    };
    const handleRedirect = path => {
      router.push(path);
    };
    watch(route, () => {
      initBreadcrumbList();
    }, {
      deep: true,
      immediate: true
    });
    // 监听中英文切换
    watch(() => store.getters.lang, () => {
      qiehuanZhEn(store.getters.lang);
    });
    function qiehuanZhEn(val) {
      if (val === 'en') {
        yuyan.value = true;
      } else {
        yuyan.value = false;
      }
    }
    return (_ctx, _cache) => {
      const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item");
      const _component_el_breadcrumb = _resolveComponent("el-breadcrumb");
      return _openBlock(), _createBlock(_component_el_breadcrumb, {
        separator: "/"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(breadcrumbList.value, (item, index) => {
          return _openBlock(), _createBlock(_component_el_breadcrumb_item, {
            key: index
          }, {
            default: _withCtx(() => [index != 0 ? (_openBlock(), _createElementBlock("span", _hoisted_1, [!yuyan.value ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(item.meta.title), 1)) : _createCommentVNode("", true), yuyan.value ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(item.meta.enTitle), 1)) : _createCommentVNode("", true)])) : (_openBlock(), _createElementBlock("span", {
              key: 1,
              class: "redirect",
              onClick: $event => handleRedirect(item.path)
            }, [!yuyan.value ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(item.meta.title), 1)) : _createCommentVNode("", true), yuyan.value ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(item.meta.enTitle), 1)) : _createCommentVNode("", true)], 8, _hoisted_4))]),
            _: 2
          }, 1024);
        }), 128))]),
        _: 1
      });
    };
  }
});